import { render } from "./FileChildPage.vue?vue&type=template&id=328fbf00"
import script from "./FileChildPage.vue?vue&type=script&lang=js"
export * from "./FileChildPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__